<template>
  <div class="home">
    <section
      class="main no-flex"
      style="margin-top: 13px;"
    >

      <UsersListingLeaveRequest
        @click="handleUser"
        @show-other-component="showOtherComponent = true"
        @show-the-component="showOtherComponent = false"
      />
      <UsersAttendance
        v-if="!showOtherComponent"
        :user="user"
      />
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import UsersAttendance from '@/components/employees/UsersAttedance.vue'
import UsersListingLeaveRequest from '@/components/employees/UsersListingLeaveRequest.vue'


export default {
  name: 'Home',
  components: {
    UsersListingLeaveRequest,
    UsersAttendance,
  },
  data() {
    return {
      user: '',
      showOtherComponent: false,
    }
  },
  computed: {
    ...mapGetters(['getIsLoading']),

  },
  methods: {
    materialId(id) {
      this.materialIdToShow = id
    },
    handleUser(id) {
      this.user = id;
    },
  },
}
</script>

<style scoped lang="scss">
@media screen and (max-width: 1800px){
  .main{
    padding: 90px 15px 15px 110px;
  }
}
@media screen and (max-width: 1200px){
  .main{
    padding: 90px 15px 15px 90px;
  }
}
@media screen and (max-width: 1041px) {
  .main {
    padding: 90px 0.75rem 15px 0.75rem;
  }
}
</style>
